import React, {useEffect, useState} from "react";
import {Modal, Button} from "react-bootstrap";
import RestRequest from "../../tools/RestRequest";
import config from "../../config";
import Swiper from "swiper";
import Recomm from "./Recomm";
import OneItem from "./OneItem";

export default function BuyWith({product_id}) {

    const [show, setShow] = useState(true);
    const [models, setModels] = useState([]);
    const [product, setProduct] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        RestRequest.one(config.restCatalog, product_id, '?expand=imageUrl').then(data => {
            if (data) setProduct(data);
        });
        RestRequest.one(config.restCatalogRecommendation, product_id).then(data => {
            if (data) {

                setModels(data);

                let dd = new Swiper(".recom-slider-container", {
                    slidesPerView: 3,
                    spaceBetween: 28,
                    loop: true,
                    // effect: 'fade',
                    autoplay: {
                        delay: 2000,
                    },
                    navigation: {
                        nextEl: '.recom-slider-button-next',
                        prevEl: '.recom-slider-button-prev',
                    }
                });
            }
        });
    }, []);

    let onShow = () => {

    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} onShow={onShow}>

            <Modal.Body>

                {models.length > 0 ? <Recomm models={models}/> : <OneItem product={product}/>}


            </Modal.Body>


            <button className="btn-main recom-slider-button" onClick={handleClose}>Продолжить покупки</button>


        </Modal>
    );
}